module.exports = __webpack_public_path__ + "static/bethanne-patrick-df6b34570c6ec621460aafcec3f746be.jpg";